import React from "react";
import {withRouter} from "react-router-dom"
import { connect } from "react-redux";
import AdminNavbar from "../../../components/Admin/adminNavbar";
import AuthAdmin from "../../../components/AuthAdmin/AuthAdmin";
import SpecfifcWorkoutAdmin from "../../../components/SpecificWorkoutAdmin/SpecificWorkoutAdmin";
import Spinner from "../../../components/Spinner/Spinner";

const SpecificWorkoutContainer = props=>{

   
    let {isAuthenticated,admin,staff,userId} = props;
    if(localStorage.getItem("idToken")){
      if(userId == null && admin == null && staff==null){
        return <Spinner/>
      }
    }

    if(!isAuthenticated || !(admin||staff)){
        return <AuthAdmin/> 
      }


    return(
        <>
         <AdminNavbar />
        <SpecfifcWorkoutAdmin/>
            
        </>
    )
}

const mapStateToProps = (state) => {
    return {
      isAuthenticated:state.auth.userId!=null,
      admin:state.auth.admin,
      staff:state.auth.staff,
      userId:state.auth.userId
    };
  };

export default  connect(mapStateToProps,null) (withRouter (SpecificWorkoutContainer))